import React from 'react';

const EditIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M13.2601 3.61877L5.0501 12.3088C4.7401 12.6388 4.4401 13.2888 4.3801 13.7388L4.0101 16.9788C3.8801 18.1488 4.7201 18.9488 5.8801 18.7488L9.1001 18.1988C9.5501 18.1188 10.1801 17.7888 10.4901 17.4488L18.7001 8.75877C20.1201 7.25877 20.7601 5.54877 18.5501 3.45877C16.3501 1.38877 14.6801 2.11877 13.2601 3.61877Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.8899 5.07031C12.3199 7.83031 14.5599 9.94031 17.3399 10.2203"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M3 22.0195H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
